export const FORM_SCOPES = 'form.below, form.text_inside_input_field';

export function configureValidation(forms) {
	const defaultErrorPlacement = forms.config.errorPlacement;

	forms.config.unhighlight = function(element, errorClass, validClass) {
		if (!element.name) return true;

		let $el = $(element);
		let isOptionGroup = ['radio', 'checkbox'].includes(element.type);

		$el.removeClass(errorClass).addClass(validClass);
		$(element.form).find(`label[for='${element.name}']`).removeClass(errorClass).addClass(validClass);

		if (this.numberOfInvalids() === 0) {
			$el.closest('.form-wrapper').find('.alert-danger').hide();
		}

		if (isOptionGroup) {
			$el.closest('.form-group, fieldset.form-group').find('.form-check-input').removeClass('is-invalid');
		} else {
			$el.removeClass('is-invalid');
			$el.closest('.form-floating').removeClass('is-invalid');
		}

		$el.closest('.form-group, fieldset.form-group').find('.invalid-feedback').removeClass('d-block');
	};

	forms.config.errorPlacement = function(error, element) {
		if (element.closest(FORM_SCOPES).length === 0) {
			if (defaultErrorPlacement) return defaultErrorPlacement(error, element);
			return error.insertAfter(element);
		}

		let $group = element.closest('.form-group, fieldset.form-group');
		if (!$group.length) return;

		let isOptionGroup = ['radio', 'checkbox'].includes(element[0].type);

		if (isOptionGroup) {
			$group.find('.form-check-input').addClass('is-invalid');
		} else {
			element.addClass('is-invalid');
			element.closest('.form-floating').addClass('is-invalid');
		}

		let $target = isOptionGroup ? $group : element.closest('.input-group');
		if (!$target.length) $target = $group;

		let $feedback = $target.find('> .invalid-feedback');
		if (!$feedback.length) {
			$feedback = $('<div class="invalid-feedback"></div>');
			$target.append($feedback);
		}

		$feedback.addClass('d-block').html(error.html());
	};
}
